import './App.css';
import AppMain from "./AppLayout/AppMain";
import Loader from './loader/index';
import { SnackbarProvider } from "./component/SnackbarContext";
import { LoadScript } from "@react-google-maps/api";
function App() {
    const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  return (
    <div>
      <Loader />
       <SnackbarProvider>
         <LoadScript googleMapsApiKey={apiKey}>
           <AppMain />
          </LoadScript>
       </SnackbarProvider>
    
    </div>
  );
}

export default App;
